export let BillClientsResultsResponseType = /*#__PURE__*/function (BillClientsResultsResponseType) {
  BillClientsResultsResponseType["Succeeded"] = "succeeded";
  BillClientsResultsResponseType["Failed"] = "failed";
  BillClientsResultsResponseType["InProgress"] = "inProgress";
  return BillClientsResultsResponseType;
}({});